import { RequestRoomDTO } from '@/dto/responseDto/request-room.dto';
import http from '@/httpCommon/axiosClient';

class RoomService {
    create = async () => {
        const response = await http.post(`/room`, {});
        return response?.data;
    };

    getRoomDetail = async (id: any, isNew: boolean | undefined) => {
        const response = await http.get(`/booking/order/${id}?new=${isNew}`);
        return response?.data;
    };

    getOrderDetail = async (id: any) => {
        const response = await http.get(`/booking/order/orderById/${id}`);
        return response?.data;
    };

    checkInRoomDetail = async (id: any, body: any) => {
        const response = await http.post(`/booking/order/${id}`, body);
        return response?.data;
    };

    updateRoomDetail = async (id: any, body: any) => {
        const response = await http.put(`/booking/order/${id}`, body);
        return response?.data;
    };

    getListLoaiPhong = async () => {
        const response = await http.get(`/phong/loai_phong`);
        return response?.data;
    };

    cleanRoom = async (id: any) => {
        const response = await http.get(`/booking/order/cleanroom/${id}`);
        return response?.data;
    };

    getAll = async (params: any) => {
        const res = await http.get('/phong/phong', { params });
        return res?.data;
    };

    createAdmin = async (body: RequestRoomDTO) => {
        const res = await http.post('/phong/phong', body);
        return res?.data;
    };

    update = async (id: string | number, body: RequestRoomDTO) => {
        const res = await http.put(`/phong/phong/${id}`, body);
        return res?.data;
    };
    delete = async (id: string | number) => {
        const res = await http.delete(`/phong/phong/${id}`);
        return res?.data;
    };
}
export default new RoomService();
